import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 w-full z-50 py-4 bg-white shadow-sm overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-6">
        <div className="flex justify-between items-center">
          {/* Logo and Brand */}
          <div className="flex-shrink-0 flex flex-col items-center space-y-1 font-domine mt-[-45px]">
            <div className="flex items-center">
              <div className="w-26 h-20">
                <img
                  src="Royal Rise_OPP 1.svg"
                  alt="RoyalRise Logo"
                  className="w-full"
                />
              </div>
              {/* <Link
                to="/"
                className="text-3xl font-extrabold text-gray-800"
              >
                Royal<span className="text-[#1865a5]">Rise</span>
              </Link> */}
            </div>
            <p className="text-sm text-center w-full text-gray-600">
              Royalrise Tours and Travels Private Limited
            </p>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8 font-domine text-gray-800">
            <Link to="/" className="hover:text-[#1865a5] font-medium">
              Home
            </Link>
            <Link to="/aboutUs" className="hover:text-[#1865a5]">
              About Us
            </Link>
            <Link to="/service" className="hover:text-[#1865a5]">
              Services
            </Link>
            <Link to="/why-choose-us" className="hover:text-[#1865a5]">
              Why Choose Us
            </Link>
            <Link to="/rental-packages" className="hover:text-[#1865a5]">
              Rental Packages
            </Link>
            <Link to="/contact" className="hover:text-[#1865a5]">
              Contact Us
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-800 hover:text-[#1865a5] p-2"
            >
              <span className="sr-only">Open menu</span>
              {!isOpen ? (
                <div className="space-y-2">
                  <span className="block w-6 h-0.5 bg-current"></span>
                  <span className="block w-6 h-0.5 bg-current"></span>
                  <span className="block w-6 h-0.5 bg-current"></span>
                </div>
              ) : (
                <div className="relative w-6 h-6">
                  <span className="absolute block w-6 h-0.5 bg-current transform rotate-45 top-2.5"></span>
                  <span className="absolute block w-6 h-0.5 bg-current transform -rotate-45 top-2.5"></span>
                </div>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 font-domine bg-white">
            <Link
              to="/"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 text-[#1865a5] font-medium"
            >
              Home
            </Link>
            <Link
              to="/aboutUs"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 hover:text-[#1865a5]"
            >
              About Us
            </Link>
            <Link
              to="/service"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 hover:text-[#1865a5]"
            >
              Services
            </Link>
            <Link
              to="/why-choose-us"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 hover:text-[#1865a5]"
            >
              Why Choose Us
            </Link>
            <Link
              to="/rental-packages"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 hover:text-[#1865a5]"
            >
              Rental Packages
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 hover:text-[#1865a5]"
            >
              Contact Us
            </Link>
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
